import { connect, MapStateToProps } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { getDefinitionParticipants } from "../../../../selectors";
import { WorkflowEditorProps } from "../../../../types";
import { ParticipantsProviderComponent, ParticipantsProviderComponentProps } from "./ParticipantsProviderComponent";

type StateProps = Pick<ParticipantsProviderComponentProps, "definitionParticipants">;

const mapStateToProps: MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (state, { hostKey }) => ({
    definitionParticipants: getDefinitionParticipants(state, hostKey),
});

export const ParticipantsProvider = connect(mapStateToProps)(ParticipantsProviderComponent);
